import { isNullOrUndefined } from 'src/app/validation';
import { EncrdecrService } from './../../Auth/encrdecr.service';
import { IPOServiceService } from './../../services/iposervice.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomLoaderService } from 'src/app/services/custom-loader.service';
import { DocumentDirectoryService } from 'src/app/services/document-directory.service';
declare var $: any;
declare var require: any;
const FileSaver = require("file-saver");
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js'
declare var $: any;

@Component({
  selector: 'app-tally-sheet',
  templateUrl: './tally-sheet.component.html',
  styleUrls: ['./tally-sheet.component.scss']
})
export class TallySheetComponent implements OnInit {

  today: Date = new Date();

  // table array
  tallySheetList = []

  // pdf array
  tallysheet = []

  CompanyList = []
  LoginId: string;
  G_UserType: number;
  G_LoginId: string;
  G_SubbrokerCode: string;
  G_ROLEID: number;
  EmpCode: string;
  CompanyID: any;
  CompanyName : "";
  TotalApplicationAmount : "";
  TotalApplicationRejected : "";
  TotalApplicationCount : "";
  fileName: string;

  constructor(private IPOServiceService : IPOServiceService, private EncrdecrService : EncrdecrService,private Loader: CustomLoaderService) {
  }

  ngOnInit() {
    debugger
    this.BindCompanyList();
    if (this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')) != null && parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))) == 2) {
      this.G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));
      this.LoginId = this.G_LoginId = this.EncrdecrService.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'))
      this.G_SubbrokerCode = this.EncrdecrService.getDecr(sessionStorage.getItem('Hldq31TLYwRbLJ8'));
    }
    if (this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')) != null && parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))) == 1) {

      this.G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));
      this.LoginId = this.G_LoginId = this.EncrdecrService.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'))
      this.EmpCode = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
      this.G_ROLEID = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('5gE4QWzFXWKewRC')));
    }
    if (this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')) != null && parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))) == 3) {
      this.G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));
      this.LoginId = this.G_LoginId = this.EncrdecrService.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'))
      //this.PANNO = this.EncrdecrService.getDecr(sessionStorage.getItem('Hldq31TLYwRbLJ8'));
      //console.log(this.PANNO);
    }
  }

  ngAfterViewInit() {
    $("select").select2();
    $('.CustomSelectCompany').on('change', (e: any) => this.OnChangeCompany(e));

  }

  OnChangeCompany(e : any){
    let ID = e.target.value;
    this.CompanyID = ID;
    this.BindTallySheetList(this.CompanyID,'CompanyId')
  }
  calldatatable(para) {
$("#dataTable_tally_sheet").DataTable().clear().draw();
      $('#dataTable_tally_sheet').DataTable().destroy();
    $(document).ready(function () {
      $.fn.dataTable.ext.errMode = 'none';

    if(para == "TallySheetList"){

      $('#dataTable_tally_sheet').DataTable({
        paging: false,
        searching: false,

        columnDefs: [

        ],

      });
    }
    else{
      // $("#dataTable_tally_sheet_pdf").DataTable().clear().draw();
      // $('#dataTable_tally_sheet_pdf').DataTable().destroy();
      $('#dataTable_tally_sheet_pdf').DataTable({
        paging: false,
        searching: false,

        columnDefs: [

        ],

      });
    }
    });
  }

  BindCompanyList(){
    this.IPOServiceService.BindNCDList().subscribe((res : any)=>{
      let data = JSON.parse(this.EncrdecrService.getDecr(res))
      this.CompanyList = data.ArrayOfResponse
    })
  }

  downloadTallySheet(id:any, flag : any) {
debugger
    if(!isNullOrUndefined(this.CompanyID)){
      let currentCompany = this.CompanyList.filter((element)=>{
        if(element.VALUEFIELD == this.CompanyID)
        {
          return element.TEXTFIELD;
        }
      })
      this.fileName = currentCompany[0].TEXTFIELD + ' TallySheet'
      let request : any;
      if(flag == 'New'){
        request = {
          UserType:this.G_UserType,
          CompanyID : this.CompanyID,
          UserId : this.LoginId,
          FileName : this.fileName,
          Flag : "GetNewTallySheetData"
        }
      }
      else if (flag == 'ByLotNo'){
        request = {
          UserType:this.G_UserType,
          CompanyID : this.CompanyID,
          UserId : this.LoginId,
          LotID : id,
          Flag : "GetDataByLotNo"
        }
      }
      this.Loader.show();
      this.IPOServiceService.GetNCDTallySheetData(request).subscribe((res : any)=>{
        debugger
        this.Loader.hide();
        let data = JSON.parse(this.EncrdecrService.getDecr(res))
        console.log(data)
        if(data.ArrayOfResponse.length>0){
          let tempArray = data.ArrayOfResponse;
          let CompanyData = data.ArrayOfResponse2;
          this.tallysheet = tempArray.map((element)=>{
            element.Amount = this.ConvertToIndianRsWithTwoDecimal(parseFloat(element.Amount))
            return element;
          })
          this.CompanyName = CompanyData[0].CompanyName;
          this.TotalApplicationAmount = this.ConvertToIndianRsWithTwoDecimal(parseFloat(CompanyData[0].TotalApplicationAmount));
          this.TotalApplicationCount = CompanyData[0].TotalApplicationCount;
          this.TotalApplicationRejected = CompanyData[0].TotalApplicationRejected;
          this.calldatatable("pdf")
          this.GeneratePDF();
          // if(flag == "New"){
            this.BindTallySheetList(this.CompanyID,'CompanyId');
          // }
        }
        else{
          this.CallAlertModal("No Applications found.")
        }


      })

    }
    else{
      this.CallAlertModal("Please Select Company.")
    }


  }

  CallAlertModal(msg: any) {
    $("#AlertModal").modal({ backdrop: "static", keyboard: false });
    $("#AlertModalContent").text(msg);
  }

  GeneratePDF(){
     const invoice = document.getElementById("invoice");
     const html =  document.getElementById("invoice").innerHTML;
      console.log(invoice);
      console.log(window);
      var opt = {
        // margin: 0.1,
        filename: `${this.fileName}.pdf`,
        image: { type: 'jpeg', quality: 5 },
         html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
        enableLinks:  false,
        pagebreak:    { mode: 'avoid-all' },
      };
      html2pdf().from(invoice).set(opt).save();
  }

  BindTallySheetList(CompanyID,Flag){
    debugger
    let request : any;
    let ApplicationNo = $('#ApplicationNo').val()
    if(Flag=="CompanyId" || isNullOrUndefined(ApplicationNo)){
      this.tallySheetList = [];
      request = {
        UserType:this.G_UserType,
        CompanyID : this.CompanyID,
        UserId : this.LoginId,
        Flag : "GetDataByCompanyId"
      }
    }
    else{
      request = {
        UserType:this.G_UserType,
        CompanyID : this.CompanyID,
        UserId : this.LoginId,
        ApplicationNo: ApplicationNo,
        Flag : "GetDataByApplicationNo"
      }
    }

    if(Flag == "ApplicationNo" && isNullOrUndefined(this.CompanyID))
    {
      this.CallAlertModal("Please select Company")
    }
    else{
// this.Loader.show();
      this.IPOServiceService.GetNCDTallySheetData(request).subscribe((res : any)=>{
        // this.Loader.hide();
        let data = JSON.parse(this.EncrdecrService.getDecr(res))
        console.log(data)
        this.tallySheetList = data.ArrayOfResponse;
        this.calldatatable("TallySheetList")
      })
    }

  }
  ConvertToIndianRsWithTwoDecimal(IpAmount: any) {
    return IpAmount.toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 0});
  }
}
